

import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import useCustomAlertStyles from './styles';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref}
   variant="filled"
    {...props} />;
});

const CustomAlert = ({open, handleClose, message, severity = 'success'}) => {
  console.log('severity', open, message, severity);
  
  const classes = useCustomAlertStyles();
  return <div className={classes.root}>
    <Snackbar open={open} autoHideDuration={3000} onClose={handleClose} >
        <Alert onClose={handleClose} sx={{ width: '100%' }} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
  </div>;
};

export default CustomAlert;


